<template>
  <gl-page icon-name="gr-block" :title="pageTitle">
    <div v-if="load === 'success'" class="contentBlock">
      <block-summary :block="block" class="contentBlock__summary" />
      <block-hashes :block="block" class="contentBlock__hashes" />
      <block-transactions :txs="block.tx" class="contentBlock__transactions" />
    </div>
    <div v-else-if="load === 'error'" class="text-gray">
      Unexpected Error!
    </div>
    <gl-loader v-else />
  </gl-page>
</template>

<script>
import GlPage from '@gl/GlPage'
import GlLoader from '@gl/GlLoader'
import BlockSummary from '@/components/Block/BlockSummary'
import BlockHashes from '@/components/Block/BlockHashes'
import BlockTransactions from '@/components/Block/BlockTransactions'
import { getBlock } from '@/services/api'
import { updatePeriod } from '@/config'

export default {
  name: 'Block',
  components: { BlockTransactions, BlockHashes, BlockSummary, GlPage, GlLoader },
  data() {
    return {
      load: 'loading',
      timer: null,
      block: {},
      requestActive: false,
    }
  },
  computed: {
    pageTitle() {
      return `Block #${this.block?.height ?? ''}`
    },
    id() {
      return this.$route?.params?.id
    },
  },
  watch: {
    $route() {
      if (this.$route.name === 'Block') {
        this.load = 'loading'
        this.loadSearch()
      }
    },
  },
  async mounted() {
    await this.loadSearch()
    if (+new Date() - this.block.time < 60 * 60 * 1000) {
      this.timer = setInterval(() => {
        this.reloadSearch()
      }, updatePeriod)
    }
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    async loadSearch() {
      if (!this.id) {
        this.load = 'error'
        return
      }

      const { data } = await getBlock(this.id)
      if (data.state === 'success') {
        this.block = data.data
        this.load = 'success'
      } else {
        this.load = 'error'
      }

      this.requestActive = false
    },
    async reloadSearch() {
      if (this.load !== 'success') return

      if (this.requestActive) return
      this.requestActive = true

      const { data } = await getBlock(this.id)
      if (data.state === 'success' && data.data.height === this.block.height) {
        this.block = data.data
      }

      this.requestActive = false
    },
  },
}
</script>

<style lang="scss" scoped>
.contentBlock {
  @include grid;

  &__summary,
  &__hashes,
  &__transactions {
    min-width: 0;
  }

  &__summary {
    @media (min-width: $breakpoint-md) {
      grid-column: 1 / 7;
    }
  }

  &__hashes {
    @media (min-width: $breakpoint-md) {
      grid-column: 7 / 13;
    }
  }

  &__transactions {
    @media (min-width: $breakpoint-md) {
      grid-column: 1 / -1;
    }
  }
}
</style>
